module.exports = __webpack_public_path__ + "assets/icon-star-gray.8b73ad76.svg";